(() => {
  const track = document.querySelector('.work-track');
  if (!track) return;
  const slides = [...track.querySelectorAll('.work-slide')];
  const prev = document.querySelector('.work-prev');
  const next = document.querySelector('.work-next');
  const count = document.querySelector('.work-count');
  const viewer = document.getElementById('work-viewer');
  const large = document.getElementById('work-viewer-image');
  const title = document.getElementById('work-viewer-title');
  const caption = document.getElementById('work-viewer-caption');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let active = 0;
  let opener;
  let frame;
  const nearest = () => {
    const left = track.getBoundingClientRect().left;
    return slides.reduce((best, item, i) => Math.abs(item.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
  };
  const update = () => {
    active = nearest();
    const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
    prev.disabled = track.scrollLeft <= 3;
    next.disabled = atEnd;
    const lastVisible = slides.reduce((last, item, i) => item.getBoundingClientRect().right <= track.getBoundingClientRect().right + 3 ? i : last, active);
    count.textContent = (active + 1) + (lastVisible > active ? '–' + (lastVisible + 1) : '') + ' / ' + slides.length;
  };
  const go = (index) => {
    const i = Math.max(0, Math.min(slides.length - 1, index));
    const offset = slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    track.scrollTo({left: offset, behavior: reduceMotion.matches ? 'auto' : 'smooth'});
  };
  prev.addEventListener('click', () => go(active - 1));
  next.addEventListener('click', () => go(active + 1));
  track.addEventListener('scroll', () => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  }, {passive: true});
  track.addEventListener('keydown', (e) => {
    if (e.target !== track) return;
    if (e.key === 'ArrowRight') {e.preventDefault();go(active + 1);}
    if (e.key === 'ArrowLeft') {e.preventDefault();go(active - 1);}
    if (e.key === 'Home') {e.preventDefault();go(0);}
    if (e.key === 'End') {e.preventDefault();go(slides.length - 1);}
  });
  window.addEventListener('resize', update);
  track.querySelectorAll('.work-open').forEach(button => button.addEventListener('click', () => {
    const item = button.closest('.work-slide');
    const img = button.querySelector('img');
    if (typeof viewer.showModal !== 'function') {window.open(img.src, '_blank', 'noopener');return;}
    opener = button;
    large.src = img.src;
    large.alt = img.alt;
    title.textContent = item.querySelector('h3').textContent;
    caption.textContent = item.querySelector('.work-caption > span').textContent;
    viewer.showModal();
  }));
  document.getElementById('work-viewer-close').addEventListener('click', () => viewer.close());
  viewer.addEventListener('click', e => {if (e.target === viewer) {const b = viewer.getBoundingClientRect();if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) viewer.close();}});
  viewer.addEventListener('close', () => {if (opener) opener.focus({preventScroll: true});});
  update();
})();

(() => {
 document.querySelectorAll('[data-pmp-price-select]').forEach(select => {
  const update = () => {
   const option = select.selectedOptions[0];
   const section = select.closest('section');
   const price = section && section.querySelector('[data-pmp-price-output]');
   if (price && option) price.textContent = option.dataset.price;
   const match = (option?.dataset.title || '').match(/up to (\d+)/i);
   section?.querySelectorAll('[data-pmp-dimension]').forEach(input => {if (match) input.max = match[1];});
  };
  select.addEventListener('change', update);update();
 });
 const project = document.getElementById('project');
 const setProject = value => {if (project && [...project.options].some(o => o.value === value)) project.value = value;};
 document.querySelectorAll('[data-project]').forEach(a => a.addEventListener('click', () => setProject(a.dataset.project)));
 setProject(new URLSearchParams(window.location.search).get('project'));
 const file = document.getElementById('PmpArtwork');
 if (file) file.addEventListener('change', () => {const f=file.files[0];file.setCustomValidity(f && f.size > 20*1024*1024 ? 'Please choose artwork smaller than 20 MB or contact info@pressmadeprints.com.' : '');});
 const form = document.getElementById('PmpProductForm');
 if (form) form.addEventListener('submit', () => {const button=form.querySelector('button[type=submit]');if(button) button.disabled=true;});
})();

(() => {
 const media = window.matchMedia('(prefers-reduced-motion: reduce)');
 if(media.matches || !('IntersectionObserver' in window)) return;
 const targets=[...document.querySelectorAll('.section-head,.product,.design-layout,.steps article,.studio > div,.hero > div')];
 if(!targets.length) return;
 const revealAll=()=>{targets.forEach(el=>el.classList.add('is-visible'));document.documentElement.classList.remove('motion-ready');};
 try {
  const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.08,rootMargin:'0px 0px -24px 0px'});
  targets.forEach(el=>{el.classList.add('pmp-reveal');if(el.matches('.product,.steps article'))el.style.setProperty('--reveal-delay',((Array.from(el.parentNode.children).indexOf(el)%3)*70)+'ms');observer.observe(el);});
  document.documentElement.classList.add('motion-ready');
  media.addEventListener('change',()=>{if(media.matches){observer.disconnect();revealAll();}});
  document.addEventListener('focusin',event=>{const target=event.target.closest('.pmp-reveal');if(target)target.classList.add('is-visible');});
 } catch(error){revealAll();}
})();
